export interface FooterLink {
    label: string;
    href: string;
    external?: boolean;
}

export interface FooterColumn {
    title: string;
    links: FooterLink[];
}

export const footerColumns: FooterColumn[] = [
    {
        title: "Navigation",
        links: [
            { label: "Start", href: "/" },
            { label: "Über mich", href: "/#about" },
            { label: "Tech Stack", href: "/#stack" },
            { label: "Projekte", href: "/#projects" },
            { label: "Veröffentlichungen", href: "/#publications" },
            { label: "Kontakt", href: "/#contact" },
        ],
    },
    {
        title: "Rechtliches",
        links: [
            { label: "Impressum", href: "/impressum" },
            { label: "Datenschutz", href: "/datenschutz" },
        ],
    },
    {
        title: "Connect",
        links: [
            { label: "LinkedIn", href: "https://www.linkedin.com/in/alexander-efremidis/", external: true },
            { label: "GitHub", href: "https://github.com/DeadP4xel", external: true },
            { label: "E-Mail", href: "mailto:alex@efremidis.de" },
        ],
    },
];
